var $ = jQuery;

function init() {

  const $shareButton = $('.share-button');
  const $openButton = $('.share-button__share-text');
  const $closeButton = $('.share-button__close');
  const $shareButtonWrapper = $('.share-button__wrapper');

  if($shareButton.length > 0) {
    $openButton.on('click',  toggleShare);
    $closeButton.on('click',  toggleShare);
  }

  function toggleShare(e) {
    e.preventDefault();
    let ind = $(e.target).hasClass('share-button__share-text') ? $openButton.index($(e.target)) : $closeButton.index($(e.target));
    $($shareButtonWrapper[ind]).toggleClass('_active');
  }
}

export { init as init };
